// extracted by mini-css-extract-plugin
export default {"container":"iY-z","list":"jY-z"};